import React, { useMemo } from 'react'
import { useRisks } from 'src/pages/Risks/risks.hooks'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

export const AssociatedRiskFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data, isLoading, error } = useRisks()

    const filterValues = useMemo(() => {
      const risks = data?.getRisksList() || []
      return risks.map((risk) => ({
        value: risk.getId(),
        label: `${risk.getCustomId()} ${risk.getName()}`.trim(),
      }))
    }, [data])

    if (error) return <></>

    return (
      <FilterDropdown
        filterParam={FilterParam.ASSOCIATED_RISK}
        filterName={FilterName.ASSOCIATED_RISK}
        filterValues={filterValues}
        isLoading={!data || isLoading}
        isNested={isNested}
      />
    )
  },
)
